import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
	title?: string;
	titleId?: string;
	desc?: string;
	descId?: string;
}
const Play = ({ title, titleId, desc, descId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={48}
		height={48}
		fill="none"
		aria-labelledby={titleId}
		aria-describedby={descId}
		{...props}
	>
		{desc ? <desc id={descId}>{desc}</desc> : null}
		{title ? <title id={titleId}>{title}</title> : null}
		<g id="Play">
			<path
				id="Vector 2"
				d="M33.5858 22.5858L22.4142 11.4142C21.1543 10.1543 19 11.0466 19 12.8284V35.1716C19 36.9534 21.1543 37.8457 22.4142 36.5858L33.5858 25.4142C34.3668 24.6332 34.3668 23.3668 33.5858 22.5858Z"
				stroke="white"
			/>
			<circle id="Ellipse 2" cx="24" cy="24" r="23.5" stroke="white" />
		</g>
	</svg>
);
export default Play;
